import React,{useState,useContext} from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { LogoSvg } from "../LayoutSvg";
import { LanguageContext } from "../../context/LanguageContext";
import "./header.css";
const Header = () => {
  const { setLanguage, translations } = useContext(LanguageContext);
  const [selectedLang, setSelectedLang] = useState("EN");

  const handleLanguageChange = (lang, label) => {
    setLanguage(lang);
    setSelectedLang(label);
  };
  return (
    <Navbar expand="lg" className="bg-body-tertiary rm-header">
      <Container>
        <Navbar.Brand href="/">{LogoSvg}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="/#about">{translations.navbar?.about}</Nav.Link>
            <Nav.Link href="/contact-us">{translations.navbar?.contact} </Nav.Link>
            <Nav.Link href="/#partner" className="cmn_btn bordered_btn">
            {translations.navbar?.becomePartner}
            </Nav.Link>
            <Nav.Link href="/#driver" className="cmn_btn">
            {translations.navbar?.becomeDriver}
            </Nav.Link>
            <NavDropdown className="nav_dropdown" title={localStorage.getItem("lang") === "se" ? "se" : "en"} id="basic-nav-dropdown">
            <NavDropdown.Item onClick={() => handleLanguageChange("en", "EN")}>ENGLISH</NavDropdown.Item>
            <NavDropdown.Item onClick={() => handleLanguageChange("se", "SWEDISH")}>SWEDISH</NavDropdown.Item>
          </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
